var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 29.3327C8.63584 29.3327 2.6665 23.3633 2.6665 15.9993C2.6665 8.63535 8.63584 2.66602 15.9998 2.66602C23.3638 2.66602 29.3332 8.63535 29.3332 15.9993C29.3332 23.3633 23.3638 29.3327 15.9998 29.3327ZM15.9998 26.666C18.8288 26.666 21.5419 25.5422 23.5423 23.5418C25.5427 21.5414 26.6665 18.8283 26.6665 15.9993C26.6665 13.1704 25.5427 10.4573 23.5423 8.45688C21.5419 6.45649 18.8288 5.33268 15.9998 5.33268C13.1709 5.33268 10.4578 6.45649 8.45737 8.45688C6.45698 10.4573 5.33317 13.1704 5.33317 15.9993C5.33317 18.8283 6.45698 21.5414 8.45737 23.5418C10.4578 25.5422 13.1709 26.666 15.9998 26.666ZM17.3332 15.9993H22.6665V18.666H14.6665V9.33268H17.3332V15.9993Z",
    fill: "#E2B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloj);
export default __webpack_public_path__ + "static/media/reloj.a1dbc7793935f5290d5ce2a435e2576d.svg";
export { ForwardRef as ReactComponent };